import instance, { customConfig } from "../Utils/Interceptors/Interceptor";

const RegistraBitacoraDetalleService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Bitacora/RegistraBitacoraDetalle",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { RegistraBitacoraDetalleService };